const rowData = [
  {
    testNumber: 1,
    readingType: 'recreational',
    question: 'How do you feel when you read a book on a rainy Saturday?',
  },
  {
    testNumber: 2,
    readingType: 'recreational',
    question: 'How do you feel when you read a book in school during free time?',
  },
  {
    testNumber: 3,
    readingType: 'recreational',
    question: 'How do you feel about reading for fun at home?',
  },
  {
    testNumber: 4,
    readingType: 'recreational',
    question: 'How do you feel about getting a book for a present?',
  },
  {
    testNumber: 5,
    readingType: 'recreational',
    question: 'How do you feel about spending free time reading a book?',
  },
  {
    testNumber: 6,
    readingType: 'recreational',
    question: 'How do you feel about starting a new book?',
  },
  {
    testNumber: 7,
    readingType: 'recreational',
    question: 'How do you feel about reading during summer vacation?',
  },
  {
    testNumber: 8,
    readingType: 'recreational',
    question: 'How do you feel about reading instead of playing?',
  },
  {
    testNumber: 9,
    readingType: 'recreational',
    question: 'How do you feel about going to a bookstore?',
  },
  {
    testNumber: 10,
    readingType: 'recreational',
    question: 'How do you feel about reading different kinds of books?',
  },
  {
    testNumber: 11,
    readingType: 'academic',
    question: 'How do you feel when a teacher asks you questions about what you read?',
  },
  {
    testNumber: 12,
    readingType: 'academic',
    question: 'How do you feel about reading workbook pages and worksheets?',
  },
  {
    testNumber: 13,
    readingType: 'academic',
    question: 'How do you feel about reading in school?',
  },
  {
    testNumber: 14,
    readingType: 'academic',
    question: 'How do you feel about reading your school books?',
  },
  {
    testNumber: 15,
    readingType: 'academic',
    question: 'How do you feel about learning from a book?',
  },
  {
    testNumber: 16,
    readingType: 'academic',
    question: "How do you feel when it's time for reading in class?",
  },
  {
    testNumber: 17,
    readingType: 'academic',
    question: 'How do you feel about stories you read in reading class?',
  },
  {
    testNumber: 18,
    readingType: 'academic',
    question: 'How do you feel when you read out loud in class?',
  },
  {
    testNumber: 19,
    readingType: 'academic',
    question: 'How do you feel about using a dictionary?',
  },
  {
    testNumber: 20,
    readingType: 'academic',
    question: 'How do you feel about taking a reading test?',
  },
];

export default rowData;
